export default {
    AUTH_TOKEN_STORAGE_IDENTIFIER: process.env.AUTH_TOKEN_STORAGE_IDENTIFIER,
    AUTH_TOKEN_IP_INFO: process.env.IPINFO_AUTH_TOKEN,
    AUTH_TOKEN_IP_INFO_URL: process.env.IPINFO_URL
}



// WEBPACK FOOTER //
// ./src/config/auth.js